import React, { useState, useRef } from "react";
import { ApiCaller } from "../../config/api/api";
import Recaptcha from "../recapcha/recaptcha";
import { CgAsterisk } from "react-icons/cg";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);
  const [captchaValue, setCaptchaValue] = useState(null);
  const recaptchaRef = useRef();

  console.log(loading);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (
      !formData.name.trim() ||
      !formData.email.trim() ||
      !formData.message.trim()
    ) {
      alert("please filled up all the required feilds");
      setLoading(false);
      return;
    }
    if (!captchaValue) {
      alert("please verify that you are not a robot");
      setLoading(false);
      return;
    }
    try {
      const response = await ApiCaller('contact-us/','POST',formData);
      alert("We will get back to you shortly", response);

      setFormData({
        name: "",
        email: "",
        message: "",
      });

      setCaptchaValue(null);
      recaptchaRef.current?.reset();
    } catch (error) {
      console.error("error", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="relative h-[60vh] md:h-[70vh] lg:h-[100vh] bg-black border-b-[1px] border-b-gray-500">
      <div className="absolute top-1/3 lg:top-1/2 left-1/2 -translate-x-1/2 -translate-y-[34.333%] lg:-translate-y-1/2 w-full lg:w-1/2 px-6">
        <div className="text-white leading-9 my-7">
          Customer feedback is the lifeblood of our business. Tell us what’s on
          your mind. We respond to all customer feedback and look forward to
          hearing from you!
        </div>
        <form className="" onSubmit={handleSubmit}>
          <label
            htmlFor="name"
            className="text-white text-xs font-bold relative"
          >
            NAME
            <div className="absolute top-[-4px] left-9 text-red-600">
              <CgAsterisk />
            </div>
          </label>
          <input
            id="name"
            name="name"
            type="text"
            onChange={handleChange}
            value={formData.name}
            className="w-full border-b text-white border-b-white bg-transparent focus:outline-none my-2 py-1 px-3"
          />
          <label
            htmlFor="email"
            className="text-white text-xs font-bold relative mt-4"
          >
            EMAIL
            <div className="absolute top-[-4px] left-9 text-red-600">
              <CgAsterisk />
            </div>
          </label>
          <input
            id="email"
            name="email"
            type="text"
            onChange={handleChange}
            value={formData.email}
            className="w-full text-white border-b border-b-white bg-transparent focus:outline-none my-2 py-1 px-3"
          />
          <label
            htmlFor="message"
            className="text-white text-xs font-bold relative mt-4"
          >
            MESSAGE
            <div className="absolute top-[-4px] left-14 text-red-600">
              <CgAsterisk />
            </div>
          </label>

          <textarea
            id="message"
            name="message"
            type="text"
            onChange={handleChange}
            value={formData.message}
            className="w-full border-b text-white border-b-white bg-transparent focus:outline-none pt-4 mt-1"
          />
          <div className="my-2">
            <Recaptcha onVerify={setCaptchaValue} />
          </div>
          <div className="my-2">
            <button
              type="submit"
              className="bg-amber-400 text-white rounded-full text-xs py-3 px-2 w-[25%]"
            >
              SUBMIT
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default Contact;
